import type { ReasoningItem } from "@/domain/entities/vistassistant/AIResponse";
import { useTranslation } from "react-i18next";
import ReasoningBlock from "./ReasoningBlock";

/** Three dots in a small wave, one after the other, in the colours of the input bar's glow (index.css). */
export const PulsingDots = () => (
    <span aria-hidden className="assistant-dots flex items-center gap-1">
        {[0, 1, 2].map((dot) => (
            <span key={dot} className="h-1.5 w-1.5 rounded-full" />
        ))}
    </span>
);

/**
 * The turn still running, in the thread (it replaces the animated logo the input bar used to
 * carry): « L'assistant réfléchit », and the reasoning so far when the Api-Ai sends it.
 */
const ThinkingIndicator = ({ reasoning }: { reasoning: ReasoningItem[] }) => {
    const { t } = useTranslation();

    return (
        <div aria-live="polite" className="flex w-full flex-col gap-1.5">
            <span className="flex items-center gap-2 text-sm text-neutral-dark">
                <PulsingDots />
                <span className="assistant-sheen">
                    {t("vistassistant.thinking")}
                </span>
            </span>
            {reasoning.length > 0 && (
                <ReasoningBlock inProgress items={reasoning} />
            )}
        </div>
    );
};

export default ThinkingIndicator;
